import { render, staticRenderFns } from "./WorkspaceFabricAdditionalElementsTool.vue?vue&type=template&id=a07c64d8&scoped=true&"
import script from "./WorkspaceFabricAdditionalElementsTool.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabricAdditionalElementsTool.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabricAdditionalElementsTool.vue?vue&type=style&index=0&id=a07c64d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07c64d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a07c64d8')) {
      api.createRecord('a07c64d8', component.options)
    } else {
      api.reload('a07c64d8', component.options)
    }
    module.hot.accept("./WorkspaceFabricAdditionalElementsTool.vue?vue&type=template&id=a07c64d8&scoped=true&", function () {
      api.rerender('a07c64d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabricAdditionalElementsTool.vue"
export default component.exports